// extracted by mini-css-extract-plugin
export var content = "_a7-1";
export var modal = "_a7-0";